
export const ICONS = {
  DOOR_LOGIN: 'https://www.glyphicons.com/img/glyphicons/basic/2x/glyphicons-basic-431-log-in@2x.png',
};

export const LINKS = {
  ETH_WALLETS: 'https://www.investopedia.com/best-ethereum-wallets-6830692',
  METAMASK_INSTALL: 'https://metamask.io/download',
  IMX_PASSPORT_INSTALL: 'https://www.immutable.com/gamers/passport',
};
